import { render } from "./MainElement.vue?vue&type=template&id=db347c48"
const script = {}

import "./MainElement.vue?vue&type=style&index=0&id=db347c48&lang=css"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__